export default __webpack_public_path__ + "static/media/Dilan_Amarasinghe.1a9358f5.pdf";